var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Components
import { Paragraph } from '../../../../atoms/Paragraph';
// Styles
import { Container } from '../../../styles/container';
// Utils
import styled from 'styled-components';
export var StyledInputError = styled(Container)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  align-self: end;\n  height: 16px;\n  ", " {\n    color: ", ";\n  }\n"], ["\n  display: block;\n  align-self: end;\n  height: 16px;\n  ", " {\n    color: ", ";\n  }\n"])), Paragraph, function (_a) {
    var errorColor = _a.errorColor;
    return errorColor;
});
var templateObject_1;
//# sourceMappingURL=StyledInputError.js.map